import { useRef } from "react";
import { useTranslation } from "react-i18next";
import uploadFileFilledIcon from "../../../static/assets/UploadFileFilled.png";

const formatFileSize = (bytes) => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes}b`;
  return `${Math.round(bytes / 1024)}kb`;
};

const ClientLogoUpload = ({
  fileName,
  fileSize,
  isComplete,
  onSelectFile,
  onRemove,
  emptyTrigger = "default",
  emptyTriggerLabel,
}) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  const fileInput = (
    <input
      ref={inputRef}
      type="file"
      accept="image/png,image/jpeg,image/webp,image/svg+xml"
      className="hidden"
      onChange={(e) => {
        const file = e.target.files?.[0];
        if (file) onSelectFile?.(file);
        e.target.value = "";
      }}
    />
  );

  if (!fileName) {
    if (emptyTrigger === "pill") {
      return (
        <div>
          <button
            type="button"
            className="modal-button modal-button-cancel !px-3 !py-2 !text-sm !font-semibold"
            onClick={() => inputRef.current?.click()}
          >
            {emptyTriggerLabel || t("settingsClients.addLogo")}
          </button>
          {fileInput}
        </div>
      );
    }

    return (
      <div>
        <label className="block text-sm font-semibold text-[#222222] mb-1">
          {t("settingsClients.logoUpload")}
        </label>
        <button
          type="button"
          className="text-sm text-[#00A7A6] font-semibold hover:underline p-0 bg-transparent border-0"
          onClick={() => inputRef.current?.click()}
        >
          {t("Upload file")}
        </button>
        {fileInput}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4 rounded-xl border border-[#d3d3d3] p-4 bg-white">
      <span className="w-10 h-10 rounded-full bg-[#F5F5F5] flex items-center justify-center shrink-0">
        <img
          src={uploadFileFilledIcon}
          alt=""
          className="w-[18px] h-[18px] object-contain"
        />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-[#222222] truncate m-0 leading-[22px]">
          {fileName}
        </p>
        <p className="text-xs text-[#5e5e5e] m-0 leading-[22px]">
          {formatFileSize(fileSize)}
          {isComplete ? ` • ${t("settingsClients.uploadComplete")}` : ""}
        </p>
      </div>
      <button
        type="button"
        className="text-[#5e5e5e] hover:text-[#AF2F3C] p-2 rounded-full shrink-0"
        onClick={onRemove}
        aria-label={t("Delete")}
      >
        <i className="fas fa-trash text-lg" aria-hidden />
      </button>
      {isComplete && (
        <span className="w-6 h-6 rounded-full bg-[#00A7A6] flex items-center justify-center shrink-0">
          <i className="fas fa-check text-white text-xs" aria-hidden />
        </span>
      )}
      {fileInput}
    </div>
  );
};

export default ClientLogoUpload;
